module.exports = __webpack_public_path__ + "static/media/3.305c46a8.png";